import { get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, LOEWE_IMAGE_UPLOAD_FIELD_PROPS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { InhaltTrenner } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import { getFormStrucWithoutComponentTable, mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
const P = AntragSchema.attributes;
const MAX_CHAR_LENGTH = 6000;

const BeschreibungDesVorhabensAntragLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm
				formStruc={formStrucPatentrecherche()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />
			<CreateForm
				formStruc={formStrucTechnologischeRealisierung()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />
			<CreateForm
				formStruc={formStrucMassnahmen()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<InhaltTrenner marginBottom='2rem' />
			<CreateForm
				formStruc={formStrucBegruendung()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default BeschreibungDesVorhabensAntragLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};

const formStrucPatentrecherche = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche, maxCharLength: MAX_CHAR_LENGTH },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucTechnologischeRealisierung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte, maxCharLength: MAX_CHAR_LENGTH },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucMassnahmen = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung, maxCharLength: MAX_CHAR_LENGTH },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucBegruendung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung, maxCharLength: MAX_CHAR_LENGTH },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStrucPatentrecherche = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.schema.attributes
						.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.schema.attributes
						.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.schema.attributes
						.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucTechnologischeRealisierung = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.schema.attributes
						.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.schema.attributes
						.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.schema.attributes
						.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucMassnahmen = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

const customFormStrucBegruendung = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.schema.attributes
						.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucBeschreibungDesVorhabensAntragLoewe = (application: any) => {
	let result: FormStrucItem[] = [];
	const bilderLengthPatentrecherche = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder.path,
		[],
	).length;
	const bilderLengthTechnologischeRealisierung = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder.path,
		[],
	).length;
	const bilderLengthMassnahmen = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder.path,
		[],
	).length;
	const bilderLengthBegruendung = get(
		application,
		P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder.path,
		[],
	).length;

	for (let i = 0; i < bilderLengthPatentrecherche; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucPatentrecherche(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Gegenwaertiger_Entwicklungsstand_Patentrecherche_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < bilderLengthTechnologischeRealisierung; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucTechnologischeRealisierung(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Technologische_Realisierung_Und_Entwicklungsschritte_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < bilderLengthMassnahmen; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucMassnahmen(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Massnahmen_Einer_Kommerzialisierung_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	for (let i = 0; i < bilderLengthBegruendung; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStrucBegruendung(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Begruendung_Einer_Staatlichen_Foerderung_Bilder,
		);
		result.push(...customFormStrucWithIndex);
	}

	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt.path,
		)
	) {
		result.push(...formStrucPruefAssistenz());
	}
	// push with spread to avoid overwriting on same parent path
	result.push(...getFormStrucWithoutComponentTable(formStrucPatentrecherche()));
	result.push(...getFormStrucWithoutComponentTable(formStrucTechnologischeRealisierung()));
	result.push(...getFormStrucWithoutComponentTable(formStrucMassnahmen()));
	result.push(...getFormStrucWithoutComponentTable(formStrucBegruendung()));

	return result;
};
